<template>
  <span class="badge" :class="toneClass" :title
    ><slot>{{ label }}</slot></span
  >
</template>

<script setup lang="ts">
import type { BadgeTone } from "@/compliance_groups/fixture/complianceGroupsTypes";
import { computed } from "vue";

const props = defineProps<{
  tone: BadgeTone;
  label?: string;
  /** Shown on hover, for detail the badge text leaves out. */
  title?: string;
}>();

const TONE_CLASS: Record<BadgeTone, string> = {
  ok: "bg-success-subtle text-success-emphasis",
  warn: "bg-warning-subtle text-warning-emphasis",
  pending: "bg-body-secondary text-body-secondary",
  forest: "bg-primary-subtle text-primary-emphasis",
};
const toneClass = computed(() => TONE_CLASS[props.tone]);
</script>
